module.exports = __webpack_public_path__ + "static/img/top-news-img.789deb3a.jpg";